<template>
  <div :class="{ 'mt-30-px': !showNavbar }">
    <notifications></notifications>
    <navbar v-if="showNavbar" :docsName="docsName" />

    <ValidationObserver v-slot="{ invalid }">
      <div class="container-fluid row">
        <div v-if="showNavbar" class="col-xl-12">
          <div class="row">
            <div class="col-xl-12 block br-t-l-0 mb-3">
              <head-menu
                :col="12"
                class="d-xl-flex"
                :headline="navbarTitel"
              ></head-menu>

              <div class="row mt-2">
                <div class="ml-4">
                  <button
                    v-if="editable"
                    v-shortkey.once="['ctrl', 's']"
                    class="btn btn-success mr-2"
                    :disabled="invalid"
                    @click="speichern"
                    @shortkey="
                      !invalid
                        ? speichern()
                        : $notify({
                            type: 'error',
                            title: $t('global.actionunsuccessful'),
                            text: $t('global.notallfieldsfilledcorrectly'),
                          })
                    "
                    :title="
                      invalid ? $t('global.notallfieldsfilledcorrectly') : ''
                    "
                  >
                    {{ $t("global.save") }}
                  </button>
                </div>
                <button class="btn btn-primary mr-2" @click="abbrechen">
                  <font-awesome-icon icon="fa-solid fa-list" class="mr-2" />
                  {{ $t("global.backtooffer") }}
                </button>
                <div class="mr-4">
                  <button
                    class="btn btn-primary"
                    @click="oeffneUebertragenModal"
                    :disabled="!id"
                    :title="!id ? $t('global.savefirst') : ''"
                  >
                    <span>{{ $t("global.transfertoanotheroffer") }}</span>
                  </button>
                </div>
                <div class="mr-4 ml-auto">
                  <button
                    class="btn btn-danger"
                    @click="oeffneLoeschenModal"
                    v-if="berechtigungen.m_lead.delete && editable"
                  >
                    <font-awesome-icon
                      class="mr-2"
                      icon="fa-duotone fa-trash"
                    />
                    <span>{{ $t("global.delete") }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-6 pr-4" :class="{ 'col-xl-12': !showNavbar }">
          <!-- START Daten -->
          <container-headline
            :headline="$t('global.masterdata')"
            :col="4"
          ></container-headline>
          <div class="row mb-3">
            <div class="col-xl-12 block br-t-l-0">
              <div class="eingabe-panel-kopf p-3">
                <div class="row">
                  <div class="col-xl-6">
                    <div class="form-group">
                      <v-select
                        v-model="einsatz.zeitraum"
                        :options="zeitraeume"
                        :placeholder="$t('global.period')"
                        @input="setZeitraum"
                      >
                        <template #option="{ von, bis }">
                          {{ datetimeToDate(von) }} –
                          {{ datetimeToDate(bis) }}
                        </template>

                        <template #selected-option="{ von, bis }">
                          {{ datetimeToDate(formatTimestamp(von)) }} –
                          {{ datetimeToDate(formatTimestamp(bis)) }}
                        </template>

                        <span slot="no-options">{{
                          $t("global.taptosearch")
                        }}</span>
                      </v-select>
                      <label>{{ $t("global.period") }}</label>
                    </div>
                  </div>
                  <div class="col-xl-3">
                    <div class="form-group">
                      <ValidationProvider
                        rules="required"
                        immediate
                        v-slot="{ passed }"
                      >
                        <label :class="{ 'text-danger': !passed }">{{
                          $t("global.From")
                        }}</label>
                        <input
                          ref="vonInput"
                          v-model="einsatz.von"
                          :class="{ 'border-danger': !passed }"
                          type="date"
                          class="form-control"
                        />
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="col-xl-3">
                    <div class="form-group">
                      <ValidationProvider
                        rules="required"
                        immediate
                        v-slot="{ passed }"
                      >
                        <label :class="{ 'text-danger': !passed }">{{
                          $t("global.till")
                        }}</label>
                        <input
                          ref="bisInput"
                          v-model="einsatz.bis"
                          :class="{ 'border-danger': !passed }"
                          type="date"
                          class="form-control"
                        />
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <!-- <div class="col-xl-6">
                    <div class="form-group">
                      <v-select
                        v-model="einsatz.angebot"
                        label="beschreibung"
                        :options="einsatzstati"
                        placeholder="Angebot"
                      >
                        <span slot="no-options">{{
                          $t("global.taptosearch")
                        }}</span>
                      </v-select>
                      <label>Angebot</label>
                    </div>
                  </div> -->
                  <div class="col-xl-6">
                    <single-select-person
                      id="ansprechpartner"
                      :person="einsatz.person"
                      :label="$t('global.youth')"
                      :allowOpen="true"
                      :editable="editable"
                      :required="true"
                      @confirmed="setPerson"
                    />
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <v-select
                        v-model="einsatz.einsatzstatus"
                        label="bezeichnung"
                        :options="einsatzstati"
                        :placeholder="$t('global.operationalstatus')"
                      >
                        <span slot="no-options">{{
                          $t("global.taptosearch")
                        }}</span>
                      </v-select>
                      <label>{{ $t("global.operationalstatus") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <textarea
                        :disabled="!editable"
                        v-model="einsatz.motivation"
                        class="form-control"
                        rows="2"
                        style="resize: vertical"
                      ></textarea>
                      <label>{{ $t("global.motivation") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-3">
                    <div class="form-check">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        v-model="einsatz.hinfahrt_ticket"
                      />
                      <label>{{ $t("global.hinfahrtticket") }}</label>
                    </div>
                  </div>
                  <div class="col-xl-3" v-if="einsatz.hinfahrt_ticket">
                    <div class="form-group">
                      <input
                        type="text"
                        class="form-control"
                        v-model="einsatz.sbb_code_hinfahrt"
                      />
                      <label>{{ $t("global.sbbcode") }}</label>
                    </div>
                  </div>
                  <div class="col-xl-3">
                    <div class="form-check">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        v-model="einsatz.rueckfahrt_ticket"
                      />
                      <label>{{ $t("global.rueckfahrtticket") }}</label>
                    </div>
                  </div>
                  <div class="col-xl-3" v-if="einsatz.rueckfahrt_ticket">
                    <div class="form-group">
                      <input
                        type="text"
                        class="form-control"
                        v-model="einsatz.sbb_code_rueckfahrt"
                      />
                      <label>{{ $t("global.sbbcode") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-6">
                    <div class="form-check">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        v-model="einsatz.einverstaendnis_gesetzliche_vertretung"
                      />
                      <label>{{
                        $t("global.einverstaendnis_gesetzliche_vertretung")
                      }}</label>
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <input
                        type="text"
                        class="form-control"
                        disabled
                        v-model="einsatz.timestamp_einverstaendnis"
                      />
                      <label>{{ $t("global.confirmationDate") }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- ENDE DATEN -->
        </div>
        <div class="col-xl-6 pr-4" :class="{ 'col-xl-12': !showNavbar }">
          <container-headline
            :headline="$t('global.educationalinstitution')"
            :col="4"
          ></container-headline>
          <div class="row mb-3">
            <div class="col-xl-12 block br-t-l-0">
              <div class="eingabe-panel-kopf p-3">
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <textarea
                        :disabled="!editable"
                        v-model="einsatz.wahl_betrieb"
                        class="form-control"
                        rows="2"
                        style="resize: vertical"
                      ></textarea>
                      <label>{{ $t("global.reasonForChoosingCompany") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <textarea
                        :disabled="!editable"
                        v-model="einsatz.kennenlernen_agriviva"
                        class="form-control"
                        rows="2"
                        style="resize: vertical"
                      ></textarea>
                      <label>{{
                        $t("global.whatToLearnDuringInternship")
                      }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <textarea
                        :disabled="!editable"
                        v-model="einsatz.aufgaben_bereiche"
                        class="form-control"
                        rows="2"
                        style="resize: vertical"
                      ></textarea>
                      <label>{{ $t("global.tasksAreasOfInterest") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <textarea
                        :disabled="!editable"
                        v-model="einsatz.beitrag_einsatz"
                        class="form-control"
                        rows="2"
                        style="resize: vertical"
                      ></textarea>
                      <label>{{
                        $t("global.contributionToSuccessfulInternship")
                      }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-6">
                    <div class="form-check">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        v-model="einsatz.ist_schueler_praktikum"
                      />
                      <label>{{ $t("global.isStudentInternship") }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <unsaved-changes-modal
        @discard="handleDiscard"
        @stay="handleStay"
        :saveFunction="invalid === true ? null : speichern"
      />
    </ValidationObserver>

    <loading-overlay v-show="loading"></loading-overlay>

    <loeschen-modal id="einsatz-loeschen-modal" @confirmed="einsatzLoeschen" />

    <angebot-suche-modal
      @confirmed="onAngebotResult"
      :uebertragen="true"
    ></angebot-suche-modal>
  </div>
</template>

<script>
import HeadMenu from "@/components/HeadMenu";

import ContainerHeadline from "@/components/ContainerHeadline";
import Navbar from "@/components/Navbar";
import DatePicker from "@/components/Datepicker";
import TimeField from "@/components/TimeField";

import { apiErrorToAlert } from "@/utils/Errorhandler";

import AppApi from "@/api/AppApi";
import store from "@/store";

import page from "@/mixins/Page";
import ChangeWatcherNew from "@/mixins/ChangewatcherNew";
import UnsavedChangesModal from "@/components/Modals/UnsavedChangesModal.vue";
import SingleSelectPerson from "@/components/global/SingleSelectPerson.vue";
import SingleSelectFirma from "@/components/global/SingleSelectFirma.vue";

import LoeschenModal from "@/components/Modals/LoeschenModal";
import EinsatzAufAngebotUebertragen from "@/newviva/components/Modale/EinsatzAufAngebotUebertragen.vue";
import AngebotSucheModal from "@/newviva/components/Modale/AngebotSucheModal.vue";

import { LADE_AUSWAHLWERTE_CRM } from "@/store/crm/actions.type";

export default {
  name: "Einsatz",
  components: {
    HeadMenu,
    Navbar,
    ContainerHeadline,
    LoeschenModal,
    UnsavedChangesModal,
    SingleSelectPerson,
    AngebotSucheModal,
  },
  mixins: [page, ChangeWatcherNew],
  store,
  props: {
    id: {
      type: String,
      default: null,
    },
    angebotId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      editable: true,
      einsatz: {
        // zeitraum: null,
        angebot: {},
        person: {},
        einsatzstatus: null,
      },
      zeitraeume: [],
    };
  },
  computed: {
    queryParams: function () {
      var params = {
        page: this.page,
        count: this.anzahlProPage,
      };

      return params;
    },

    einsatzstati() {
      if (this.$store) return this.$store.state.crm.einsatzstati;
      return [];
    },
    navbarTitel: function () {
      if (this.id) {
        return this.$t("global.deployment");
      } else {
        return this.$t("global.newapplication");
      }
    },
  },
  watch: {},
  created() {
    this.loading = true;
  },
  mounted() {
    if (this.einsatzstati?.length == 0)
      this.$store.dispatch(`crm/${LADE_AUSWAHLWERTE_CRM}`);

    this.loadeinsatz().then(() => {
      this.getZeitraeme();
    });
  },
  methods: {
    getZeitraeme() {
      AppApi.get("zeitraum/", {
        params: {
          angebotId: this.einsatz.angebot?.id || this.angebotId,
        },
      })
        .then((response) => {
          this.zeitraeume = response.data;
        })
        .catch((e) => {
          this.$notify(apiErrorToAlert(e));
        });
    },

    formatTimestamp(timestamp) {
      if (typeof timestamp === "number") {
        const date = new Date(timestamp);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        return `${day}.${month}.${year} ${hours}:${minutes}`;
      }
      return timestamp;
    },

    loadeinsatz() {
      return new Promise((resolve, reject) => {
        if (this.id) {
          AppApi.get("einsatzmaske/", { params: { einsatzId: this.id } })
            .then((response) => {
              this.initializeeinsatz(response.data);
              this.loading = false;
              resolve();
            })
            .catch((error) => {
              this.loading = false;
              reject(error);
            });
        } else {
          this.editable = true;
          this.loading = false;
          resolve();
        }
      });
    },

    initializeeinsatz(einsatz) {
      if (einsatz) {
        this.einsatz = einsatz;

        this.einsatz.von = this.germanToIso(einsatz.von);
        this.einsatz.bis = this.germanToIso(einsatz.bis);

        this.editable = true;

        if (this.berechtigungen.m_lead.update == false) this.editable = false;

        // this.initializeChangewatcher(["lead"]);
      } else {
        console.error("einsatz ist null");
      }
    },

    speichern() {
      if (this.loading) return;
      if (!this.checkHTMLValidity()) return;
      this.loading = true;

      let einsatz = JSON.parse(JSON.stringify(this.einsatz));
      let json = {};

      json.id = einsatz.id || null;
      json.von = this.isoToGerman(einsatz.von);
      json.bis = this.isoToGerman(einsatz.bis);
      json.motivation = einsatz.motivation || "";
      json.person = einsatz.person?.id;
      json.angebot = einsatz.angebot?.id || this.angebotId;
      json.einsatzstatus = einsatz.einsatzstatus?.id;
      json.hinfahrtTicket = einsatz.hinfahrt_ticket || false;
      json.sbbCodeHinfahrt = einsatz.sbb_code_hinfahrt || "";
      json.rueckfahrtTicket = einsatz.rueckfahrt_ticket || false;
      json.sbbCodeRueckfahrt = einsatz.sbb_code_rueckfahrt || "";
      json.einverstaendnisGesetzlicheVertretung =
        einsatz.einverstaendnis_gesetzliche_vertretung || false;
      json.wahlBetrieb = einsatz.wahl_betrieb || "";
      json.kennenlernenAgriviva = einsatz.kennenlernen_agriviva || "";
      json.aufgabenBereiche = einsatz.aufgaben_bereiche || "";
      json.beitragEinsatz = einsatz.beitrag_einsatz || "";
      json.istSchuelerPraktikum = einsatz.ist_schueler_praktikum || false;
      json.timestampEinverstaendnis = einsatz.timestamp_einverstaendnis || null;
      json.zeitraum = einsatz.zeitraum?.id;

      if (!this.id) {
        AppApi.post("einsatzmaske/", json)
          .then((response) => {
            this.initializeeinsatz(response.data);
            this.$notify({
              type: "success",
              title: this.$t("global.actionsuccessful"),
              text: this.$t("global.successfullysaved"),
            });

            this.$router.replace({
              name: "Einsatz",
              params: { id: response.data.id },
            });
          })
          .catch((e) => {
            this.$notify(apiErrorToAlert(e));
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        AppApi.put("einsatzmaske/", json)
          .then((response) => {
            this.initializeeinsatz(response.data);
            this.$notify({
              type: "success",
              title: this.$t("global.actionsuccessful"),
              text: this.$t("global.successfullysaved"),
            });
          })
          .catch((e) => {
            this.$notify(apiErrorToAlert(e.message));
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    oeffneUebertragenModal() {
      // this.$bus.$emit("open-einsatz-uebertragen-modal");
      this.$bus.$emit("open-angebot-suche-modal");
    },

    oeffneLoeschenModal() {
      this.$bus.$emit("openLoeschenModal", "einsatz-loeschen-modal");
    },

    einsatzLoeschen() {
      if (this.id) {
        AppApi.delete("einsatzmaske", { data: [this.id] }).then(() => {
          this.abbrechen();
        });
      } else {
        this.abbrechen();
      }
    },

    setPerson(person) {
      this.einsatz.person = person;
    },

    onAngebotResult(selectedAngebot) {
      if (selectedAngebot[0].id === this.einsatz.angebot.id) {
        this.$notify({
          type: "error",
          title: this.$t("global.couldnotbetransferred"),
          text: this.$t("global.isalreadyonselectedoffer"),
        });
        return;
      }

      AppApi.put(
        "uebertragen-einsatz/",
        {},
        {
          params: {
            einsatzId: this.einsatz.id,
            angebotId: selectedAngebot[0].id,
          },
        }
      )
        .then((response) => {
          this.initializeeinsatz(response.data);
          this.$notify({
            type: "success",
            title: this.$t("global.successfultransfer"),
            text: this.$t("global.ontransferredmission"),
          });
        })
        .catch((e) => {
          this.$notify(apiErrorToAlert(e));
        })
        .finally(() => {
          this.loading = false;
          this.getZeitraeme();
        });
    },

    abbrechen() {
      if (this.einsatz.angebot?.id) {
        this.$router.push({
          name: "Angebot",
          params: { id: this.einsatz.angebot.id, anzeige: 2 },
        });
      } else {
        this.$router.back();
      }
    },

    isoToGerman(dateString) {
      if (!dateString) {
        return null;
      }
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");

      return `${day}.${month}.${year} ${hours}:${minutes}:00`;
    },

    germanToIso(dateTimeString) {
      if (!dateTimeString) {
        return null;
      }
      const formated = this.formatTimestamp(dateTimeString);
      const [datePart, timePart] = formated.split(" ");
      const [day, month, year] = datePart.split(".");

      return `${year}-${month}-${day}`;
    },

    datetimeToDate(datetime) {
      if (!datetime) return null;
      return datetime.split(" ")[0];
    },

    checkHTMLValidity() {
      const vonInput = this.$refs.vonInput;
      const bisInput = this.$refs.bisInput;
      if (!vonInput.checkValidity()) {
        vonInput.reportValidity();
        return false;
      }
      if (!bisInput.checkValidity()) {
        bisInput.reportValidity();
        return false;
      }
      return true;
    },

    setZeitraum() {
      if (
        !this.einsatz.von ||
        this.einsatz.von < this.germanToIso(this.einsatz.zeitraum.von) ||
        this.einsatz.von > this.germanToIso(this.einsatz.zeitraum.bis)
      ) {
        this.einsatz.von = this.germanToIso(this.einsatz.zeitraum.von);
      }
      if (
        !this.einsatz.bis ||
        this.einsatz.bis < this.germanToIso(this.einsatz.zeitraum.von) ||
        this.einsatz.bis > this.germanToIso(this.einsatz.zeitraum.bis)
      ) {
        this.einsatz.bis = this.germanToIso(this.einsatz.zeitraum.bis);
      }
    },
  },
};
</script>

<style></style>
